import { Component, inject, signal } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MessageService } from 'src/app/services';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';


@Component({
  selector: 'kbm-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    
  ]
})
export class LoginDialogComponent {


  authService = inject(AuthService);
  messageService = inject(MessageService);
  fb = inject(FormBuilder);

  form = this.fb.group({

    username: this.fb.nonNullable.control('', {
      validators: [Validators.required,Validators.email],
      updateOn: 'blur'
    }),
    password: this.fb.nonNullable.control('', [Validators.required, Validators.minLength(7)])
  });

  hidepw = true;

  async doLogin() {
    try {
      if (!this.form.valid) {
        this.messageService.showMessage('Please enter username and password', 'error');
        return;
      };
      await this.authService.login(this.form.value.username!, this.form.value!.password!);
    } catch (err) {
      console.error('Login failed:', err);
      this.messageService.showMessage('Login failed: ' + err, 'error');
    }
  };


}
